var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"toggle"},_vm._l((_vm.options),function(name,key){return _c('a',{key:key,class:_vm.value === key && 'active',domProps:{"textContent":_vm._s(name)},on:{"click":function($event){return _vm.$emit('select', key)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }